import Axe from "../../assets/images/sidebar/icons/axeMark.svg";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Pagination from "../../sharedComponent/Pagination";
import React, { useContext, useEffect, useState } from "react";
import deleteicon from "../../assets/images/delete_icon_gray.svg";
import edit from "../../assets/images/edit_officeCaller.svg";
import eye from "../../assets/images/ic_show_eyes_officecaller.svg";
import BookIcon from "../../assets/images/ic_excel.svg";
import ic_search_dark from "../../assets/images/ic_search_dark.svg";
import searchicon from "../../assets/images/ic_search.svg";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

const Adminpanel = () => {
  const { sidebar, setSidebar, Dark, setDark, userData } =
    useContext(AppContext);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [showPersonal, setShowPersonal] = useState(false);
  const [showPersonaledit, setShowPersonaledit] = useState(false);
  const [category, setCategory] = useState([]);
  const [domain, setDomain] = useState([]);

  const handleUpdate = () => {
    // Handle the update logic here
    console.log("Updated Category:", category);
    console.log("Updated Domain:", domain);
    // Close the modal after updating
    setShowPersonal(false);
  };
  // show button
  const [selectedRows, setSelectedRows] = useState(10);

  const handleSelectChange = (event) => {
    setSelectedRows(event.target.value);
    console.log(`Selected number of rows: ${event.target.value}`);
    // You can add additional logic to handle the row change
  };
  // show button end

  const agentdata = [
    {
      id: 1,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
    {
      id: 2,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
    {
      id: 3,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
    {
      id: 4,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
    {
      id: 5,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
    {
      id: 6,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
    {
      id: 7,
      App: "Admin Panel",
      Type: "Admin Panel",
      Domain: "Education",
      Category: "AR,VR & Games",
      Action: "Action",
    },
  ];

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="role-content">
        <div className="sub-header-role ">
          <div className="textHeader">
            <h6 className="mt-2">App</h6>
          </div>
        </div>
        <div className="d-flex justify-content-between role-searchbar-and-btns RspSalary">
          <div className="role-table-header">
            <div className="search-input-wrapper">
              <input
                type="text"
                placeholder="Search "
                // onChange={(e) => {
                //   setSearchValue(e.target.value);
                //   setCurrentPage(0);
                // }}
              />
              {Dark === "lightMode" ? (
                <img src={searchicon} alt="" />
              ) : (
                <img src={ic_search_dark} alt="" />
              )}
            </div>
            <div className="entries-wrapper">
              <p>Entries per page</p>
              <select
                className="form-select select-drop-icon"
                aria-label="Default select example"
                // onChange={(e) => {
                //   setUsersPerPage(e.target.value);
                //   setCurrentPage(0);
                // }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
              </select>
            </div>
          </div>

          <div className="import-export-btn-wrapper mt-4">
            <div className="booksIcon">
              <img src={BookIcon} className="innerIconsBtn" alt="" />
            </div>
          </div>
        </div>

        <div id="crm-call-form">
          <div className="table-wrapper" id="scrol-tblNtable-wrapper-af">
            <table>
              <thead>
                <tr className="firstTabelRow">
                  <th scope="col"> Sr.No.</th>
                  <th scope="col">App</th>

                  <th scope="col">Type</th>
                  <th scope="col">Domain</th>
                  <th scope="col">Category</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {agentdata.map((item, index) => (
                  <tr key={index} className="table-row-custom">
                    <td>{item.id}</td>
                    <td>{item.App}</td>

                    <td> {item.Type}</td>
                    <td> {item.Domain}</td>
                    <td> {item.Category}</td>

                    <td>
                      <div>
                        <img
                          onClick={() => setShowPersonaledit(true)}
                          src={edit}
                          alt="Image 1"
                          className="cell-image"
                        />

                        <Link to="/Adminpanel">
                          <img
                            src={eye}
                            alt="Image 2"
                            className="cell-image ml-1"
                          />
                        </Link>

                        <Link to="" onClick={handleShow3}>
                          <img
                            src={deleteicon}
                            alt="Image 2"
                            className="cell-image ml-1"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
          // data={EmployeeList}
          // pageChangeHandler={pageChangeHandler}
          // usersPerPage={usersPerPage}
          // currentPage={currentPage}
          // searchValue={searchValue}
          // searchedDataPageCounts={searchedDataPageCounts}
          />
        </div>
      </div>

      <Modal
        size="xl"
        show={showPersonal}
        aria-labelledby="modal-90w"
        className="add-task-modal-main"
        centered
      >
        <Modal.Header className="add-task-modal-header">
          <Modal.Title id="example-modal-sizes-title-lg">
            Add Category
          </Modal.Title>
          <div className="rightAxe" onClick={() => setShowPersonal(false)}>
            <img src={Axe} alt="" />
          </div>
        </Modal.Header>
        <div className="lineSeperate"></div>
        <Form noValidate>
          <Modal.Body>
            <div className="mainContentmodel">
              <div className="row add-task-modal-inputs" id="popup-form-af">
                <div className="col-lg-6 smallInpt">
                  <label htmlFor="" className="mb-2 text-grey">
                    Category *
                  </label>
                  <input
                    type="text"
                    className="form-control tasKCategory1 mb-2"
                    required
                  />
                  <div className="invalid-feedback">Please select end date</div>
                </div>

                <div className="col-lg-6 mb-1">
                  <label htmlFor="" className="mb-2 text-grey">
                    Domain
                  </label>
                  <select
                    className="form-select tasKCategory1 mb-2"
                    aria-label="Default Select Priority"
                  >
                    <option value="12">Education</option>
                    <option value="13">Food Delivery</option>
                    <option value="14">Lifestyle</option>
                    <option value="15">Real Estate</option>
                    <option value="16">Social Media</option>
                    <option value="17">Transport &amp; Logistics</option>
                    <option value="18">Travel Booking</option>
                    <option value="19">Accounting</option>
                    <option value="20">Ecommerce</option>
                    <option value="22">Services</option>
                    <option value="23">Non-governmental Organization</option>
                    <option value="24">Chatbot App</option>
                    <option value="25">CRM</option>
                  </select>
                </div>
              </div>
            </div>
          </Modal.Body>

          <div className="lineSeperate"></div>
          <div className="d-flex justify-content-end align-items-center mainBtnsSub">
            <button
              type="button"
              className="btn-width cancelBtn mx-3"
              onClick={() => setShowPersonal(false)}
            >
              Cancel
            </button>
            <button className="btn-width saveBtn">Update</button>
          </div>
        </Form>
      </Modal>
      <Modal
        size="xl"
        show={showPersonaledit}
        aria-labelledby="modal-90w"
        className="add-task-modal-main"
        centered
      >
        <Modal.Header className="add-task-modal-header">
          <Modal.Title id="example-modal-sizes-title-lg">Edit App</Modal.Title>
          <div className="rightAxe" onClick={() => setShowPersonaledit(false)}>
            <img src={Axe} alt="" />
          </div>
        </Modal.Header>
        <div className="lineSeperate"></div>
        <Form noValidate>
          <Modal.Body>
            <div className="mainContentmodel">
              <div className="row add-task-modal-inputs" id="popup-form-af">
                <div className="col-lg-6 smallInpt">
                  <label htmlFor="category" className="mb-2 text-grey">
                    App *
                  </label>
                  <input
                    id="category"
                    type="text"
                    placeholder="Admin Panel"
                    className="form-control tasKCategory1 mb-2"
                    // value={category}
                    // onChange={(e) => setCategory(e.target.value)}
                    required
                  />
                </div>

                <div className="col-lg-6 mb-1">
                  <label htmlFor="domain" className="mb-2 text-grey">
                    App Type *
                  </label>
                  <select
                    id="domain"
                    className="form-select tasKCategory1 mb-2"
                    aria-label="Default Select Priority"
                    placeholder="Admin Panel"
                    // value={domain}
                    // onChange={(e) => setDomain(e.target.value)}
                  >
                    <option value="12">Education</option>
                    <option value="13">Food Delivery</option>
                    <option value="14">Lifestyle</option>
                    <option value="15">Real Estate</option>
                    <option value="16">Social Media</option>
                    <option value="17">Transport &amp; Logistics</option>
                    <option value="18">Travel Booking</option>
                    <option value="19">Accounting</option>
                    <option value="20">Ecommerce</option>
                    <option value="22">Services</option>
                    <option value="23">Non-governmental Organization</option>
                    <option value="24">Chatbot App</option>
                    <option value="25">CRM</option>
                  </select>
                </div>
              </div>

              <div className="row add-task-modal-inputs" id="popup-form-af">
                <div className="col-lg-6 smallInpt">
                  <label htmlFor="category" className="mb-2 text-grey">
                    App Base
                  </label>
                  <input
                    id="category"
                    type="text"
                    className="form-control tasKCategory1 mb-2"
                    // value={category}
                    // onChange={(e) => setCategory(e.target.value)}
                    required
                  />
                </div>

                <div className="col-lg-6 mb-1">
                  <label htmlFor="domain" className="mb-2 text-grey">
                    Icon *
                  </label>
                  <input
                    id="category"
                    type="text"
                    className="form-control tasKCategory1 mb-2"
                    // value={category}
                    // onChange={(e) => setCategory(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="row add-task-modal-inputs" id="popup-form-af">
                <div className="col-lg-6 smallInpt">
                  <label htmlFor="category" className="mb-2 text-grey">
                    Domain *
                  </label>
                  <select
                    id="domain"
                    className="form-select tasKCategory1 mb-2"
                    aria-label="Default Select Priority"
                    placeholder="Admin Panel"
                    // value={domain}
                    // onChange={(e) => setDomain(e.target.value)}
                  >
                    <option value="12">Education</option>
                    <option value="13">Food Delivery</option>
                    <option value="14">Lifestyle</option>
                    <option value="15">Real Estate</option>
                    <option value="16">Social Media</option>
                    <option value="17">Transport &amp; Logistics</option>
                    <option value="18">Travel Booking</option>
                    <option value="19">Accounting</option>
                    <option value="20">Ecommerce</option>
                    <option value="22">Services</option>
                    <option value="23">Non-governmental Organization</option>
                    <option value="24">Chatbot App</option>
                    <option value="25">CRM</option>
                  </select>
                </div>

                <div className="col-lg-6 mb-1">
                  <label htmlFor="domain" className="mb-2 text-grey">
                    Category *
                  </label>
                  <select
                    id="domain"
                    className="form-select tasKCategory1 mb-2"
                    aria-label="Default Select Priority"
                    placeholder="Admin Panel"
                    // value={domain}
                    // onChange={(e) => setDomain(e.target.value)}
                  >
                    <option value="12">Education</option>
                    <option value="13">Food Delivery</option>
                    <option value="14">Lifestyle</option>
                    <option value="15">Real Estate</option>
                    <option value="16">Social Media</option>
                    <option value="17">Transport &amp; Logistics</option>
                    <option value="18">Travel Booking</option>
                    <option value="19">Accounting</option>
                    <option value="20">Ecommerce</option>
                    <option value="22">Services</option>
                    <option value="23">Non-governmental Organization</option>
                    <option value="24">Chatbot App</option>
                    <option value="25">CRM</option>
                  </select>
                </div>
              </div>
            </div>
          </Modal.Body>

          <div className="lineSeperate"></div>
          <div className="d-flex justify-content-end align-items-center mainBtnsSub">
            <button
              type="button"
              className="custoBtnForCrmCall mx-3"
              onClick={() => setShowPersonaledit(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="custoBtnForCrmCall"
              onClick={() => setShowPersonaledit(false)}
            >
              Update
            </button>
          </div>
        </Form>
      </Modal>

      <Modal
        className="delete-news-modal"
        show={show3}
        onHide={handleClose3}
        dialogClassName="modal-90w"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="delete-title">
            Delete Confirmation
          </Modal.Title>
        </Modal.Header>
        <div class="lineSeperate"></div>
        <Modal.Body className="delete-body ps-4">
          <p>Are you sure you want to delete this App ?</p>
        </Modal.Body>

        <div className="lineSeperate"></div>
        <div className="d-flex justify-content-end align-items-center mainBtnsSub">
          <button className="btn-width cancelBtn mx-3" onClick={handleClose3}>
            Cancel
          </button>
          <button
            className="btn-width saveBtn"
            onClick={() => {
              handleClose3();
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Adminpanel;
